import Api from "lib/Api";

export default function loadServerSettings() {
  return Api.bareGet("/settings.json", { withoutOrganization: true }).then(
    (response) => response.data,
  );
}
